import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import * as Setting from '../../utils/AuthUtils'
import Tournament from './Tournament';
import { api } from '../../AppConfig';

function RoutedTournament(props) {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  const { hasRights } = props;
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const tournamentQuery = useQuery({ 
    queryKey: [`tournament${id}`], 
    queryFn: () => 
      fetch(api.tournaments().detailsById(id).href, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        }})
        .then((res) =>
        res.json(), 
      )
  })
  const participantsQuery = useQuery({ 
    queryKey: [`participants${id}`], 
    queryFn: () => 
      fetch(api.tournaments().players(id).href).then((res) =>
        res.json(), 
      )
  })

  const multipliersQuery = useQuery({ 
    queryKey: [`multipliers`], 
    queryFn: () => 
      fetch(api.tournaments().listMultipliers().href).then((res) =>
        res.json(), 
      )
  })

  const lpiseasonsQuery = useQuery({
    queryKey: ['lpiseasons'],
    queryFn: () => 
      fetch(api.tournaments().lpiSeasonsList().href).then((res) =>
        res.json(), 
      )
  })

  const archetypesQuery = useQuery({
    queryKey: ['archetypes'],
    queryFn: () => 
      fetch(api.decks().archetypesList().href).then((res) =>
        res.json(), 
      )
  })
  
  //otherwise we fetch the data and pass to the display component
  const byesQuery = useQuery({ 
    queryKey: ['byes'], 
    queryFn: () => 
      fetch(api.byes().list().href).then((res) =>
        res.json(), 
      )
  })

  const addPlayerQuery = useMutation({
    mutationFn: async (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      let response = await fetch(api.tournaments().addPlayer(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })
      .catch((error) => {
        console.log(error);
        throw new Error('An error occurred');
      })
      if (response.status === 403) throw new Error('Forbidden!');
    },
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Successfully added player to event!');
      window.location.reload(false)
    },
    onError: () => {
      // console.warn('data arrivati dopo onError:', data, error, variables,context)
      message.error('Operation failed! Probably you do not have permission to do this.');
    },
    onSettled: (data, error) => {
      if (error === null) {
        // console.warn('non ho avuto errori!');
        queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
        queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      }
    },
  })

  const deletePlayerQuery = useMutation({
      mutationFn: (p) => {
        console.warn('sono arrivato all interno di deletePlayerQuery mutation con questo oggetto:', p);
        fetch(api.tournaments().removePlayer(p.tournamentId).href, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + Setting.getToken(),
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(p),
        })},
      onSuccess: async () => {
        // Invalidate and refetch
        message.success('Player successfully removed!');
        // window.location.reload(false)
      },
      onSettled: async () => {
        await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
        await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      }
  })

  const rankingUpdateQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.tournaments().setRanking(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p.players),
      })},
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Ranking successfully updated!');
      // window.location.reload(false)
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // window.location.reload(false)
    },
  })

  const addDecklistQuery = useMutation({
    mutationFn: async (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      // console.warn('son arrivato a chiamare i ws per aggiungere un mazzo, chiamo questa url:', api.decks().add(p.stageId,p.isTournament,p.playerId).href);
      const response = await fetch(api.decks().add(p.stageId,p.isTournament,p.playerId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        throw new Error(errorData.message || 'An error occurred while adding the decklist.');
      }

      return response.json();
    },
    // we need to catch the error in onError, otherwise it is swallowed and the user does not see any message
    // but it doesn
    onError: () => {
      // console.warn('data arrivati dopo onError:');
      message.error('Operation failed! Contact administrator for more information.');
    },
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Decklist successfully updloaded!');
      // window.location.reload(false)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // window.location.reload(false)
    },
  })

  if (!id) return (<div></div>);
  
  return <Tournament 
          id={id} 
          tournament={tournamentQuery} 
          participants={participantsQuery}
          archetypes={archetypesQuery} 
          addPlayer={addPlayerQuery}
          deletePlayer={deletePlayerQuery}
          updateRanking={rankingUpdateQuery}
          hasRights={hasRights}
          multipliers={multipliersQuery}
          lpiSeasons={lpiseasonsQuery}
          byes={byesQuery}
          addDecklist={addDecklistQuery}
          />;
}

export default RoutedTournament;